<template>
  <div class="count_down_goal" v-if="settings">
    <h2 class="widget-title">{{ settings.value.show_title_block }}</h2>

    <div class="content">
      <div ref="tick" class="tick">
        <div data-repeat="true" aria-hidden="true">
          <span data-view="flip"></span>
        </div>
      </div>

      <div class="date" v-if="settings.value.goal_period_interval">
        Period:
        <span>{{settings.value.goal_period_interval[0] | date }}</span>
        -
        <span>{{settings.value.goal_period_interval[1] | date}}</span>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import axios from "axios";
    import widgetHelper from "@/mixins/widgetHelper";

import Tick from "@pqina/flip";
import "@pqina/flip/dist/flip.min.css";

const goalRequestCache = new Map();

const buildGoalCacheKey = (role, settings) => `${role}:${JSON.stringify(settings)}`;

export default {
        mixins: [widgetHelper],
        components: {
        },
        filters: {
          date(val){
              return new Date(val * 1000).toDateString()
          }
        },
        computed: {
            ...mapGetters(["streams"]),
        },
        data() {
            return {
                current_amount: 0,
                tick: null
            };
        },
        mounted() {
            const board = this.$store.state.boards.boards[this.$store.state.boards.active];
            const role = board ? board.default_role : null;

            if (role){
              this.tick = Tick.DOM.create(this.$refs.tick, {
                  value: this.settings.value.goal_to_reach
              });

              this.onSuccessfulPayment = (e) => {
                goalRequestCache.delete(buildGoalCacheKey(e.role, this.settings.value));
                this.getData(e.role);
              };

              this.getData(role);

              this.$bus.$on("successful_payments_stream", this.onSuccessfulPayment);
            }
        },
        methods: {
            applyGoalResult(result) {
                const amount = Math.floor(this.settings.value.goal_to_reach - result);

                this.current_amount = amount >= 0 ? amount : 0;

                if (this.tick) {
                  this.tick.value = this.current_amount;
                }

                if (this.current_amount <= 0){
                  this.$bus.$emit("show_reached_goal_modal", {
                      goal_to_reach: this.settings.value.goal_to_reach
                  });
                }
            },
            getData(role) {
                const cacheKey = buildGoalCacheKey(role, this.settings.value);

                if (goalRequestCache.has(cacheKey)) {
                  return goalRequestCache.get(cacheKey).then((result) => {
                    this.applyGoalResult(result);
                  });
                }

                const request = axios({
                    url: 'api/sales-statistic/goal',
                    method: 'POST',
                    headers: {
                        secret_key: '039e3cea804ae6c10a53ab3a4b7ae4c9'
                    },
                    data: {
                        board_role: role,
                        widget_settings: this.settings.value
                    },
                }).then((res) => res.data.result);

                goalRequestCache.set(cacheKey, request);

                return request.then((result) => {
                  this.applyGoalResult(result);
                }).catch((error) => {
                  goalRequestCache.delete(cacheKey);
                  throw error;
                });
            },
        },
        destroyed() {
            if (this.$refs.tick) {
              Tick.DOM.destroy(this.$refs.tick);
            }

            if (this.onSuccessfulPayment) {
              this.$bus.$off('successful_payments_stream', this.onSuccessfulPayment);
            }
        }
    };
</script>

<style lang="scss" scoped>
  .count_down_goal{

    .content{
      padding: 50px;
      background: linear-gradient(to right, rgba(2, 18, 18, 0.6) 0, rgba(99, 99, 99, 0.6) 49%, rgba(33, 33, 33, 0.6) 100%);

      .goal{
        font-size: 40px;
        text-align: center;
        margin: 0 0 25px;
        color: #94cd7c;
        line-height: 1;

        span{
          font-weight: 600;
          font-size: 50px;
        }
      }

      .tick {
        text-align: center;
        font-size: 90px;
      }

      .date{
        margin-top: 50px;
        text-align: center;
        font-size: 24px;

        span{
          font-weight: 600;
          font-size: 30px;
        }
      }
    }
  }
</style>
